import {
    DateField,
    Datagrid,
    DeleteButton,
    Edit,
    EditButton,
    List,
    NumberField,
    NumberInput,
    required,
    Show,
    ShowButton,
    SimpleForm,
    SimpleShowLayout,
    TextField,
    TextInput,
} from 'react-admin';

import { ADMIN_FEEDBACK_RESOURCE } from '../admin/adminFeedbackDataProvider';
import { StatusChipField } from '../admin/StatusChipField';

const feedbackListFilters = [
    <TextInput key="search" source="search" label="Search" alwaysOn />,
    <TextInput key="status" source="status" label="Status" alwaysOn />,
];

export const FeedbackList = () => (
    <List filters={feedbackListFilters} perPage={10} sort={{ field: 'feedbackId', order: 'DESC' }}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="feedbackId" label="Feedback Id" />
            <TextField source="subject" />
            <StatusChipField source="status" label="Status" />
            <NumberField source="rating" />
            <TextField source="email" />
            <TextField source="mobile" />
            <DateField source="createdAt" showTime />
            <DateField source="updatedAt" showTime />
            <ShowButton />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const FeedbackShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="feedbackId" label="Feedback Id" />
            <TextField source="subject" />
            <StatusChipField source="status" label="Status" />
            <NumberField source="rating" />
            <TextField source="email" />
            <TextField source="mobile" />
            <TextField source="message" />
            <DateField source="createdAt" showTime />
            <DateField source="updatedAt" showTime />
        </SimpleShowLayout>
    </Show>
);

export const FeedbackEdit = () => (
    <Edit resource={ADMIN_FEEDBACK_RESOURCE}>
        <SimpleForm>
            <TextInput source="feedbackId" label="Feedback Id" disabled fullWidth />
            <TextInput source="subject" disabled fullWidth />
            <TextInput
                source="status"
                label="Status"
                validate={required()}
                helperText="Only status can be updated. Use exact values such as pending or done."
                fullWidth
            />
            <NumberInput source="rating" min={1} max={5} step={1} disabled />
            <TextInput source="email" disabled fullWidth />
            <TextInput source="mobile" disabled fullWidth />
            <TextInput source="message" disabled multiline minRows={8} fullWidth />
            <TextInput source="createdAt" label="Created At" disabled fullWidth />
            <TextInput source="updatedAt" label="Updated At" disabled fullWidth />
        </SimpleForm>
    </Edit>
);